<input
  type="checkbox"
  [id]="id"
  [formControl]="control"
  class="toggleCheckbox" />
<label style="width: 390px" [for]="id" class="toggleContainer">
  <div class="toggleValue">
    <mat-icon
      *ngIf="option1Icon"
      style="margin-right: 16px"
      [class]="option1Icon"
      [svgIcon]="option1Icon"></mat-icon>
    <span class="text-trim">{{ option1 }}</span>
  </div>
  <div class="toggleValue">
    <span class="text-trim">{{ option2 }}</span>
    <mat-icon
      *ngIf="option2Icon"
      style="margin-left: 16px"
      [class]="option2Icon"
      [svgIcon]="option2Icon"></mat-icon>
  </div>
</label>
